/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

@import "../../scss/vars";

:host {
  width: 100%;
  height: 100%;
  position: relative;

  .discovery-tile {
    width: 100%;
    height: calc(100% - 20px);
    min-height: calc(100% - 20px);
    display: flex;
    flex-direction: column;

    .tile-title {
      padding: 5px;
      margin: 0;
      text-align: center;
      color: var(--warp-view-font-color, $w10-charcoal);
    }

    .tile-desc {
      padding: 5px;
      margin: 0;
      text-align: center;
      color: var(--warp-view-font-color, $w10-charcoal);
    }

    .discovery-chart-wrapper {
      cursor: auto;
      text-align: left;
      flex-grow: 2;
      position: relative;
      width: 100%;
      height: 100%;
      max-height: 100%;
      min-height: 0;
    }
  }
}
